goog.provide('yext.location.MultipleSelect');
goog.provide('yext.location.MultipleSelectModel');
goog.provide('yext.location.SearchableMultipleSelect');

goog.require('yext');
goog.require('yext.helpers');
goog.require('yext.location.helpers');
goog.require('yext.autocomplete.Autocomplete');

/**
 * Model for the multiple select field
 *
 * @constructor
 */
yext.location.MultipleSelectModel = function() {
  this.options = [];
  this.displayOptions = [];
  this.numElided = 0;
};

/**
 * Update the state of an option on the model
 *
 * @param {MultipleSelectModel.Option} option The option being updated
 * @param {!Object} data Data to update the option with
 */
yext.location.MultipleSelectModel.prototype.update = function(option, data) {
  if (option.update(data)) {
    this.message('updated');
  }
};

/**
 * Set the options during a reorder event
 */
yext.location.MultipleSelectModel.prototype.setOptions = function(options) {
  this.options = options;
  this.message('updated');
};

/**
 * Set the display options
 */
yext.location.MultipleSelectModel.prototype.setDisplayOptions = function(displayOptions) {
  this.displayOptions = displayOptions;
};

yext.location.MultipleSelectModel.prototype.setNumElided = function(numElided) {
  this.numElided = numElided;
  this.message('updated');
};

/**
 * @param {string} message Message to trigger
 */
yext.location.MultipleSelectModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @param {!Object} data Initial values
 * @constructor
 */
yext.location.MultipleSelectModel.Option = function(data) {
  this.value = data.value;
  this.label = data.label;
  this.indeterminate = data.indeterminate;
  this.selected = data.selected;
};

/**
 * @param {!Object} data Updates to the option
 */
yext.location.MultipleSelectModel.Option.prototype.update = function(data) {
  var changed = false;
  if (data.selected != undefined && this.selected != data.selected) {
    this.selected = data.selected;
    changed = true;
  }
  if (data.indeterminate != undefined && this.indeterminate != data.indeterminate) {
    this.indeterminate = data.indeterminate;
    changed = true;
  }
  return changed;
};

/**
 * Create a copy of the important properties for saving state
 *
 * @return {!Object} Model properties
 */
yext.location.MultipleSelectModel.Option.prototype.getData = function() {
  return {
    indeterminate: this.indeterminate,
    value: this.value,
    selected: this.selected,
  };
};

/**
 * Data keyed on strings for export
 *
 * @return {!Object} Model properties keyed with strings
 */
yext.location.MultipleSelectModel.Option.prototype.getDataForExport = function() {
  return {
    'indeterminate': this.indeterminate,
    'value': this.value,
    'selected': this.selected,
  };
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.MultipleSelect = function($ctx) {
  this.$ctx = $ctx;
  this.$options = $ctx.find('.js-options-list');
  this.$displayOptions = $ctx.find('.js-display-options-container');
  this.$fieldValue = $ctx.find('.js-field-value');

  this.model = new yext.location.MultipleSelectModel();
  this.fieldName = $ctx.find('input[name="field"]').val();
  this.optionsByValue = {};
  this.listItemsByValue = {};
  this.storedValues = {
    storedOptions: [],
    storedDisplayOptions: [],
    storedNumElided: 0,
  };
  this.labelsCache = {};

  this.parseOptionsFromDOM();
  this.fillLabelsCache();
  this.setFieldValue();
  this.render();
  this.storeValue();
  this.bindings();
};

/**
 * Cache some labels if they need to be restored
 */
yext.location.MultipleSelect.prototype.fillLabelsCache = function() {
  for (var i = 0; i < this.model.options.length; i++) {
    var model = this.model.options[i];
    this.labelsCache['' + model.value] = model.label;
  }
};

/**
 * Parse the initial state from the DOM
 */
yext.location.MultipleSelect.prototype.parseOptionsFromDOM = function() {
  var self = this;

  this.$options.find('.js-option').each(function() {
    var $this = $(this);
    var $checkbox = $this.find('input[type=checkbox]');
    var option = new yext.location.MultipleSelectModel.Option({
      value: $checkbox.val(),
      indeterminate: $checkbox.data('indeterminate'),
      selected: $checkbox.prop('checked'),
      label: self.sanitizeLabel($this),
    });
    self.newOption(option, $this);
  });

  this.$displayOptions.find('.js-display-option').each(function() {
    var displayOption = new yext.location.MultipleSelectModel.Option({
      label: $(this).closest('li').html(),
    });
    self.model.displayOptions.push(displayOption);
  });

  if (this.$displayOptions.find('.js-num-elided').length) {
    self.model.numElided =
      this.$displayOptions.find('.js-num-elided').data('count');
  }
};

/**
 * Removes things that should not be part of the label
 * @param {!jQuery} $item The list item from edit modes
 */
yext.location.MultipleSelect.prototype.sanitizeLabel = function($item) {
  var $label = $item.find('label').clone();
  $label.find('input').remove();
  return $label.html();
};

/**
 * Bind a new option model to its DOM component
 * @param {yext.location.MultipleSelectModel.Option} option
 * @param {!jQuery} $option The option element
 */
yext.location.MultipleSelect.prototype.newOption = function(option, $option) {
  this.model.options.push(option);
  this.optionsByValue['' + option.value] = option;
  this.listItemsByValue['' + option.value] = $option;
  this.bindCheckbox($option.find('input[type=checkbox]'), option);
};

/**
 * Store the state for use in reset
 */
yext.location.MultipleSelect.prototype.storeValue = function() {
  this.storedValues.storedOptions = [];
  for (var i = 0; i < this.model.options.length; i++) {
    this.storedValues.storedOptions.push(this.model.options[i].getData());
  }
  this.storedValues.storedDisplayOptions = [];
  for (var i = 0; i < this.model.displayOptions.length; i++) {
    this.storedValues.storedDisplayOptions.push(this.model.displayOptions[i].getData());
  }
  this.storedValues.storedNumElided = this.model.numElided;
};

/**
 * Bind checkbox actions to the model
 *
 * @param {!jQuery} $checkbox
 * @param {MultipleSelectModel.Option} option The option being updated
 */
yext.location.MultipleSelect.prototype.bindCheckbox = function($checkbox, option) {
  var self = this;
  $checkbox.on('click, change', function() {
    // Force selected to be true if in indeterminate state so that
    // first click changes indeterminate -> determinate and selected
    var selected = option.indeterminate ? true : $checkbox.prop('checked');
    self.model.update(option, {
      selected: selected,
      indeterminate: false,
    });
  });
};

/**
 * Listens for updates from the model and rerenders the view
 */
yext.location.MultipleSelect.prototype.bindings = function() {
  var self = this;
  $(this.model).on('updated', function() {
    self.onUpdate();
  });

  this.$ctx.find('.js-remove-elided-lists').click(function() {
    self.model.setNumElided(0);
  });
};

/**
 * Things to do after updates are made
 */
yext.location.MultipleSelect.prototype.onUpdate = function() {
  this.setFieldValue();
  this.toggleAddOption();
  this.render();
  this.message('updated');
};

/**
 * Sets the value of the field in a hidden input
 */
yext.location.MultipleSelect.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getData()));
};

/**
 * Reset the field to a stored state
 */
yext.location.MultipleSelect.prototype.reset = function() {
  this.set({
    options: this.storedValues.storedOptions,
    displayOptions: this.storedValues.storedDisplayOptions,
    numElided: this.storedValues.storedNumElided,
  });
};

/**
 * Render the current state of the model
 */
yext.location.MultipleSelect.prototype.render = function() {
  var self = this;
  this.$options.find('.js-option').each(function() {
    var $this = $(this);
    var $checkbox = $this.find('input[type=checkbox]');
    var option = self.optionsByValue[$checkbox.val()];
    $checkbox.prop({
      checked: option.selected,
      indeterminate: option.indeterminate,
    });
    self.renderOption($this, option);
  });

  var message = yext.msgn('1 list', '{0} lists', this.model.numElided);
  this.$ctx.find('.js-elided-message').html(message);
  this.$ctx.find('.js-elided-mode-wrap').toggle(this.model.numElided !== 0);
};

/**
 * Extension point for rendering the option
 */
yext.location.MultipleSelect.prototype.renderOption = function($option, option) {
  // Override me!
};

/**
 * Gets the option from its element
 */
yext.location.MultipleSelect.prototype.getOption = function($el) {
  var $option = $el.closest('.js-option');
  if ($option.length) {
    return this.optionsByValue[$option.find('input[type=checkbox]').val()];
  }
  $option = $el.closest('.js-display-option');
  if ($option.length) {
    return this.optionsByValue[$option.data('value')];
  }
};

/**
 * Gets the option element by value
 * @param {string} value
 * @return {!jQuery} The corresponding display element
 */
yext.location.MultipleSelect.prototype.getOptionElement = function(value) {
  var $option;
  this.$options.find('.js-option').each(function() {
    var $this = $(this);
    if ($this.find('input[type=checkbox]').val() == value) {
      $option = $this;
      return false; // break
    }
  });
  return $option;
};

/**
 * Gets the option display element by id
 * @param {string} value
 * @return {!jQuery} The corresponding display element
 */
yext.location.MultipleSelect.prototype.getOptionDisplayElement = function(value) {
  var $option;
  this.$displayOptions.find('.js-display-option').each(function() {
    var $this = $(this);
    if ($this.data('value') == value) {
      $option = $this;
      return false; // break
    }
  });
  return $option;
};

/**
 * Broadcast messages with the field as context
 */
yext.location.MultipleSelect.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Get the display value for the field
 *
 * @return {string} Unordered list html string
 */
yext.location.MultipleSelect.prototype.getDisplayValue = function() {
  if (this.model.numElided > 0) {
    return yext.msgn('1 list', '{0} lists', this.model.numElided);
  }

  var selected = [];
  var hasIndeterminate = false;

  for (var i = 0; i < this.model.displayOptions.length; i++) {
    if (this.model.displayOptions[i].selected) {
      selected.push(this.model.displayOptions[i]);
    }
    if (this.model.displayOptions[i].indeterminate) {
      hasIndeterminate = true;
    }
  }

  if (hasIndeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else if (selected.length) {
    return this.templateDisplayOptions(selected);
  } else {
    return yext.location.helpers.emptyFieldMessage();
  }
};

yext.location.MultipleSelect.prototype.templateDisplayOptions = function(selected) {
  var items = [];
  for (var i = 0; i < selected.length; i++) {
    items.push(
      $('<li>', {
        'role': 'option',
        'class': 'js-display-option',
        'data-value': selected[i].value,
      }).html(selected[i].label));
  }
  return $('<ul>').append(items);
};

/**
 * Set the fields value
 *
 * @param {!Object} field Field data
 */
yext.location.MultipleSelect.prototype.set = function(field) {
  // If the field is elided, ignore any return options, adding them to the
  // elided count
  if (yext.isNumber(field.numElided) && field.numElided > 0) {
    this.model.numElided = field.numElided + field.options.length;
    this.model.setOptions([]);
    this.model.setDisplayOptions([]);
    this.optionsByValue = {};
    this.listItemsByValue = {};
    this.$options.find('.js-option').remove();
    this.onUpdate();
    return;
  }

  // first update the options
  var self = this;
  var optionsByValue = {};

  for (var i = 0; i < field.options.length; i++) {
    var option = field.options[i];
    optionsByValue[option.value] = option;
  }

  for (var i = this.model.options.length - 1; i >= 0; i--) {
    var option = this.model.options[i];
    var update = optionsByValue[option.value];

    if (update) {
      this.model.update(option, {
        selected: update['selected'],
        indeterminate: update['indeterminate'],
      });
    } else {
      // Remove from model
      this.model.options.splice(i, 1);

      // Clean up element
      var $li = this.listItemsByValue[option.value];
      if ($li) {
        $li.remove();
      }

      delete this.optionsByValue[option.value];
      delete this.listItemsByValue[option.value];
    }

    this.fillInLabel(option);
  }

  // Cleanup generated options
  this.$options.find('.js-option').each(function() {
    var value = $(this).find('input[type=checkbox]').val();
    var option = optionsByValue[value];
    if (!option) {
      delete self.optionsByValue[value];
      delete self.listItemsByValue[value];
    }
  });

  // update display options
  // if display options aren't returned then we use the options returned
  var displayOptions = [];
  if (field.displayOptions.length === 0) {
    for (var i = 0; i < field.options.length; i++) {
      var option = field.options[i];

      if (option.selected) {
        option.label = this.optionsByValue[option.value].label;
        this.fillInLabel(option);
        displayOptions.push(new yext.location.MultipleSelectModel.Option(option));
      }
    }
  } else {
    for (var i = 0; i < field.displayOptions.length; i++) {
      var option = new yext.location.MultipleSelectModel.Option(field.displayOptions[i]);
      this.fillInLabel(option);
      displayOptions.push(option);
    }
  }
  this.model.setDisplayOptions(displayOptions);

  this.fillLabelsCache();
  this.onUpdate();
};

/**
 * Fill in a missing label from the cache
 */
yext.location.MultipleSelect.prototype.fillInLabel = function(option) {
  if (!option.label) {
    option.label = this.labelsCache['' + option.value];
  }
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.MultipleSelect.prototype.getData = function() {
  var selected = [];
  for (var i = 0; i < this.model.options.length; i++) {
    selected.push(this.model.options[i].getDataForExport());
  }
  return {
    'options': selected,
    'numElided': this.model.numElided,
  };
};

/**
 * Returns true if the field is empty (no selections)
 * @return {boolean}
 */
yext.location.MultipleSelect.prototype.isEmpty = function() {
  return this.size() === 0 && this.model.numElided === 0;
};

/**
 * Returns count of selected options
 * @return {number}
 */
yext.location.MultipleSelect.prototype.size = function() {
  var count = 0;
  for (var i = 0; i < this.model.options.length; i++) {
    if (this.model.options[i].selected) {
      count++;
    }
  }
  return count;
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.SearchableMultipleSelect = function($ctx) {
  // Call parent constructor
  yext.location.MultipleSelect.call(this, $ctx);

  this.$multipleSelect = $ctx.find('.js-searchable-multiple-select');
  this.$searchItemTemplate = $($ctx.find('.js-search-item-template').html());

  this.optionTemplate = $ctx.find('.js-option-template').html();
  this.sourceUrl = this.$multipleSelect.data('sourceUrl');
  this.sourceData = this.$multipleSelect.data('sourceData');
  this.maxOptions = this.$multipleSelect.data('maxOptions');

  this.addOptionWrapper = this.$ctx.find('.js-add-option-wrap');

  this.bindDeleteOption();
  this.bindAddOption();
  if (this.maxOptions > 1) {
    this.bindReorderOption();
  }
};
goog.inherits(yext.location.SearchableMultipleSelect, yext.location.MultipleSelect);

/**
 * Bind the add option link
 */
yext.location.SearchableMultipleSelect.prototype.bindAddOption = function() {
  var self = this;

  this.$ctx.find('.js-add-option').click(function() {
    self.addSearchItem();
  });

  // Bind a single searcher when the field starts empty
  var $searchItem = this.$ctx.find('.js-search-options');
  if ($searchItem.length) {
    this.bindSearch($searchItem);
  }
};

/**
 * Return the total number of options in a searchable select
 */
yext.location.SearchableMultipleSelect.prototype.totalOptionSize = function() {
  return this.size() + this.$ctx.find('.js-search-options').length;
};

/**
 * Add an empty search item to the end of the list
 */
yext.location.SearchableMultipleSelect.prototype.addSearchItem = function() {
  if (this.totalOptionSize() < this.maxOptions) {
    var $searchItem = this.$searchItemTemplate.clone();
    this.$ctx.find('.js-options-list').append($searchItem);
    this.bindSearch($searchItem);
    this.toggleAddOption();
  }
};

/**
 * Set the fields value
 *
 * @param {!Object} field Field data
 */
yext.location.SearchableMultipleSelect.prototype.set = function(field) {
  yext.location.MultipleSelect.prototype.set.call(this, field);
  this.cleanup();
  if (this.isEmpty()) {
    this.addSearchItem();
  }
};

/**
 * Cleanup to be done on save or reset
 */
yext.location.SearchableMultipleSelect.prototype.cleanup = function() {
  this.$options.find('.js-search-options').remove();
};

/**
 * Search through the available options
 *
 * @param {string} term Search term
 */
yext.location.SearchableMultipleSelect.prototype.search = function(term) {
  var matches = [];
  term = term.toLowerCase();
  for (var i = 0; i < this.model.options.length; i++) {
    var option = this.model.options[i];
    if (option.label.toLowerCase().indexOf(term) != -1) {
      matches.push({
        label: option.label,
        value: option.value,
      });
    }
  }
  return matches;
};

/**
 * Extension point for rendering the option
 *
 * @param {!jQuery} $option Option element
 * @param {!Object} option Option model
 */
yext.location.SearchableMultipleSelect.prototype.renderOption = function($option, option) {
  $option.toggle(option.selected);
};

/**
 * Replace a search item with a selected option
 *
 * @param {!Object} selection Details about the selected option
 * @param {!jQuery} $searchItem the item being replaced
 */
yext.location.SearchableMultipleSelect.prototype.setSelected = function(selection, $searchItem) {
  var option = this.optionsByValue[selection.value];
  var $option;
  if (!option) { // Fields that provide a sourceUrl will generate options on the fly
    var labelText = this.parseSelectionLabel(selection);
    $option = this.templateNewOption(selection.value, labelText);
    option = new yext.location.MultipleSelectModel.Option({
      value: selection.value,
      indeterminate: false,
      selected: true,
      label: labelText,
    });
    this.newOption(option, $option);
    this.labelsCache['' + option.value] = option.label;
  } else {
    $option = this.listItemsByValue[selection.value];
    this.model.update(option, {
      selected: true,
      indeterminate: false,
    });
  }
  $searchItem.replaceWith($option);
  this.reordered();
};

/**
 * Parse the selected option and if the search response provides a displayLabel,
 * this will be used preferentially over the plain label.
 *
 * @param {!Object} selection Details about the selected option
 * @return {string} The label text either wrapped in <a> tag or without html tags.
 */
yext.location.SearchableMultipleSelect.prototype.parseSelectionLabel = function(selection) {
  if (selection.displayLabel) {
    return selection.displayLabel;
  } else {
    // Note (yliu): Have to add span tag manually, because for some strings like "Bob's Burger"·
    // jQuery will throw unrecognized expression exception.
    return $('<span>' + selection.label + '</span>').text();
  }
};

/**
 * Template a new option
 * @param {value} The stored value for this option
 * @param {label} The label for this option
 */
yext.location.SearchableMultipleSelect.prototype.templateNewOption = function(value, label) {
  return $(this.optionTemplate
    .replace('#VALUE#', value)
    .replace('#LABEL#', label));
};

/**
 * Bind autocomplete search
 *
 * @param {!jQuery} $searchItem The row item with search input
 */
yext.location.SearchableMultipleSelect.prototype.bindSearch = function($searchItem) {
  var self = this;
  var $results = this.$ctx.find('.js-search-results');
  var $input = $searchItem.find('input[type=text]');

  var autocomplete = new yext.autocomplete.Autocomplete({
    $input: $input,
    $target: $searchItem.find('.js-search-results-target'),
    $activeRegion: $searchItem,
    source: function(request, response) {
      self.handleSearch(request, response);
    },
  });

  $(autocomplete).on('select', function(e, selection) {
    self.setSelected(selection, $searchItem);
    autocomplete.destroy();
  });

  $(autocomplete).on('hide', function() {
    $results.hide();
  });

  $(autocomplete).on('show', function() {
    $results.show();
    $results.position({
      'my': 'left top',
      'at': 'left bottom',
      'of': $input,
    });
  });
};

/**
 * This method is called by the autocompleter to provide results. For search configurations with
 * a sourceUrl, an ajax GET request will be made with sourceData and the search term to generate
 * options. The response method must be called must with an array of objects that minimally match
 * {label: '...', value: ...}.
 *
 * @param {string} request The search term
 * @param {function()} response A callback that is made once the search is complete
 */
yext.location.SearchableMultipleSelect.prototype.handleSearch = function(request, response) {
  if (this.sourceUrl) {
    var self = this;
    $.ajax({
      url: this.sourceUrl,
      data: $.extend({}, this.sourceData, {'term': request, 'businessId': yext.businessId}),
      success: function(results) {
        response(self.filterSelected(results));
      },
    });
  } else {
    // This searches the local list of hidden options
    response(this.filterSelected(this.search(request)));
  }
};

/**
 * Filters out any results that have already been selected
 * @param {!Array} results List of results whose format must match {label: '...', value: ...}
 */
yext.location.SearchableMultipleSelect.prototype.filterSelected = function(results) {
  var selected = [];

  for (var i = 0; i < this.model.options.length; i++) {
    if (this.model.options[i].selected) {
      selected.push(this.model.options[i].value + '');
    }
  }

  var filtered = [];
  for (var i = 0; i < results.length; i++) {
    if (selected.indexOf('' + results[i].value) === -1) {
      filtered.push(results[i]);
    }
  }

  return filtered;
};

/**
 * Bind the delete option buttons
 */
yext.location.SearchableMultipleSelect.prototype.bindDeleteOption = function() {
  var self = this;

  this.$options.on('click', '.js-remove-option', function() {
    self.onDeleteOption($(this).closest('li'));
  });
};

/**
 * Triggered when a searcher or option is deleted
 * @param {!jQuery} $li The list item being removed
 */
yext.location.SearchableMultipleSelect.prototype.onDeleteOption = function($li) {
  if ($li.hasClass('js-option')) {
    var $checkbox = $li.find('[type=checkbox]');
    var option = this.optionsByValue[$checkbox.val()];
    this.model.update(option, {
      selected: false,
      indeterminate: false,
    });
    $li.hide();
  } else {
    $li.remove();
  }
  this.toggleAddOption();
};

/**
 * Allows options to be reordered
 */
yext.location.SearchableMultipleSelect.prototype.bindReorderOption = function() {
  var self = this;
  this.$options.sortable({
    handle: '.js-reorder-option',
    axis: 'y',
    stop: function(e, ui) {
      self.reordered();
      // Note (dwen): Firefox sets top/left to 0 on stop, which causes the
      // image to be misaligned the next time it gets dragged. Explicitly
      // set top/left to auto to fix this.
      ui.item
        .css('top', 'auto')
        .css('left', 'auto');
    },
    containment: this.$options,
    tolerance: 'pointer',
  });
};

/**
 * Triggered when the options list is reordered
 */
yext.location.SearchableMultipleSelect.prototype.reordered = function() {
  var self = this;
  var selected = [];
  var unselected = [];

  this.$options.find('.js-option').each(function() {
    var $this = $(this);
    var $checkbox = $this.find('input[type=checkbox]');
    var option = self.optionsByValue[$checkbox.val()];
    if (option.selected) {
      selected.push(option);
    } else {
      unselected.push(option);
    }
  });

  this.model.setOptions(selected.concat(unselected));
};

yext.location.MultipleSelect.prototype.toggleAddOption = function() {
  if (this.addOptionWrapper) {
    $(this.addOptionWrapper).toggle(this.totalOptionSize() < this.maxOptions);
  }
};
